module.exports = __webpack_public_path__ + "48f765c18ff5aae8a3cc5df94d0bc6d6.twig";